// src/pages/CreateEssens/Step5.js
import React, { useState } from 'react';

function Step5({ value, onChange, onNext, onBack }) {
  const [lokalGrense, setLokalGrense] = useState(value || '');

  const handleSubmit = () => {
    onChange(lokalGrense);
    onNext();
  };

  return (
    <div className="bg-white text-black min-h-screen flex flex-col items-center px-6 py-10">
      <div className="mb-10 p-6 border border-gray-300 rounded bg-gray-100 max-w-xl text-center shadow">
        <h2 className="text-xl font-semibold mb-4">Valgfritt Grensefilter</h2>
        <p className="text-sm mb-2">
          Her kan du definere ord eller uttrykk du ikke ønsker i din digitale opplevelse.
        </p>
        <p className="text-sm mb-4 italic text-gray-700">
          Eksempel: banning, visse navn, triggere, temaer – ett per linje.
        </p>
      </div>

      <div className="w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4">Steg 5: Ditt Grensefilter</h2>
        <textarea
          rows="6"
          value={lokalGrense}
          onChange={(e) => setLokalGrense(e.target.value)}
          placeholder="Skriv hvert ord/uttrykk på en ny linje..."
          className="w-full p-3 border border-gray-300 rounded mb-4 text-black"
        />

        <div className="flex justify-between">
          <button
            onClick={onBack}
            className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
          >
            Tilbake
          </button>
          <button
            onClick={handleSubmit}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Hopp Over. lagreKodeEssens
          </button>
        </div>
      </div>
    </div>
  );
}

export default Step5;
